
/**
 * Module dependencies.
 */

import { fetchProduct } from 'src/api/app/products/fetch-product';
import { routes } from 'src/core/routes';
import ProductPage, { Props } from 'src/components/pages/product';
import React, { ReactElement } from 'react';

/**
 * `Product` page.
 */

const Product = (props: Props): ReactElement => <ProductPage {...props} />;

/**
 * Export `getServerSideProps`.
 */

export async function getServerSideProps({ locale, params, query }) {
  const product = await fetchProduct({
    hasPreview: query?.preview,
    locale,
    slug: params?.slug
  });

  if (!product) {
    return {
      redirect: {
        destination: `/${locale}${routes[locale].collections}`,
        permanent: true
      }
    };
  }

  return {
    props: {
      locale,
      product
    }
  };
}

/**
 * Export `Product` page.
 */

export default Product;
